// Vendor Components
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {isEmpty} from 'lodash';

// Actions
import * as overlayActions from '../../actions/overlay-actions';

// Components
import MainHeader from './main-header';
import OverlayPortal from '../../components-core/overlay-portal';
import Loading from '../../components-core/loading';

class Main extends Component {
    getProps() {
        return {
            onClick: this.handleClick,
        };
    }

    handleClick = ({overlays, closeAllOverlays}) => {
        if (!isEmpty(overlays)) {
            closeAllOverlays();
        }
    };

    render() {
        const {auth, children} = this.props;
        const {user: {credentialsNonExpired} = {}} = auth;

        return (
            <div className="main" {...this.getProps()}>
                {credentialsNonExpired ? (
                    <>
                        <MainHeader />

                        <div className="main--content">{children}</div>
                        <OverlayPortal />
                    </>
                ) : (
                    <div>
                        <MainHeader />
                        <div style={{position: 'absolute', marginTop: 25, width: '100%', height: 100}}>
                            <Loading
                                className="thumbnail--loading"
                                loading={true}
                                progressText="Authenticating..."
                                small={true}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

Main.propTypes = {
    auth: PropTypes.object,
    children: PropTypes.node,
    closeAllOverlays: PropTypes.func.isRequired,
    overlays: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        overlays: state.overlays,
        auth: state.auth,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...overlayActions}, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
